<template>
    <div id="produk-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Pembayaran',
                    to: { path: '/produk' },
                    exact: true,
                },
                {
                    text: 'Paket',
                    to: { path: '/produk' },
                    exact: true,
                },
                { text: !$route.query.id ? 'Buat Paket' : 'Update Paket' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Paket Baru" : "Ubah Paket" }}
        </h3>

        <v-card flat class="pa-5">
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            url
                                                ? url
                                                : require('@/assets/img/unavailable.png')
                                        "
                                        :key="keyimg"
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 mt-5 font-weight-bold"
                                color="success"
                                depressed
                                dark
                            >
                                <v-icon class="mr-1">mdi-file-upload</v-icon>
                                Upload
                            </v-btn>

                            <input
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Ukuran gambar 400 x 500
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Maximum size is 300 KB
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="9">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Nama <span class="red--text">*</span>
                                    </v-list-item-title>
                                    <v-text-field
                                        class="pb-2"
                                        placeholder="Nama Paket"
                                        v-model="data.package_name"
                                        dense
                                        maxLength="100"
                                        :hint="
                                            data.package_name
                                                ? data.package_name.length +
                                                  '/100'
                                                : '0/100'
                                        "
                                        persistent-hint
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Deskripsi paket
                                        <span class="red--text">*</span>
                                    </v-list-item-title>
                                    <v-textarea
                                        placeholder="Deskripsi paket"
                                        v-model="data.package_description"
                                        dense
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Fitur <span class="red--text">*</span>
                                    </v-list-item-title>
                                    <ckeditor
                                        :editor="editor"
                                        v-model="data.feature_description"
                                        :config="editorConfig"
                                    ></ckeditor>

                                    <div
                                        v-if="data.feature_description"
                                        class="mt-1 text-right grey--text"
                                    >
                                        {{
                                            characterCounter(
                                                data.feature_description,
                                            )
                                        }}
                                        karakter
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="pa-0 mt-6">
                                <v-row>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold font-size-14 pt-2 pb-1"
                                                >
                                                    Harga Normal
                                                </v-list-item-title>
                                                <v-text-field
                                                    type="number"
                                                    v-model="data.normal_price"
                                                    prefix="Rp"
                                                    dense
                                                    outlined
                                                    separator=","
                                                    :value="
                                                        data.normal_price =
                                                            Number(
                                                                data.normal_price,
                                                            )
                                                    "
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold font-size-14 pt-2 pb-1"
                                                >
                                                    Harga Asli
                                                    <span class="red--text"
                                                        >*</span
                                                    >
                                                </v-list-item-title>
                                                <v-text-field
                                                    type="number"
                                                    placeholder="Harga Asli"
                                                    v-model="data.actual_price"
                                                    prefix="Rp"
                                                    dense
                                                    outlined
                                                    separator=","
                                                    :value="
                                                        data.actual_price =
                                                            Number(
                                                                data.actual_price,
                                                            )
                                                    "
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Potongan Referral
                                    </v-list-item-title>
                                    <v-text-field
                                        type="number"
                                        v-model="data.referral_discount"
                                        prefix="Rp"
                                        dense
                                        outlined
                                        placeholder="Potongan Referral"
                                        separator=","
                                        :value="
                                            data.referral_discount = Number(
                                                data.referral_discount,
                                            )
                                        "
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Diskon
                                    </v-list-item-title>
                                    <v-text-field
                                        type="number"
                                        v-model="data.discount"
                                        placeholder="Diskon Paket"
                                        prefix="%"
                                        dense
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <div class="mb-8">
                                <div style="margin-left: -12px">
                                    <v-checkbox
                                        label="Gunakan waktu diskon berakhir"
                                        v-model="is_discount_exp"
                                        :false-value="false"
                                        :true-value="true"
                                        class="pa-0 ma-0"
                                        outlined
                                        hide-details
                                    />
                                </div>

                                <div v-if="is_discount_exp">
                                    <div
                                        class="font-weight-bold font-size-14 pb-1 pt-3 black--text"
                                    >
                                        Diskon Berakhir
                                    </div>

                                    <div class="mt-3">
                                        <v-row>
                                            <v-col cols="6">
                                                <v-menu
                                                    ref="menu"
                                                    :close-on-content-click="
                                                        true
                                                    "
                                                    transition="slide-y-reverse-transition"
                                                    offset-y
                                                    min-width="auto"
                                                >
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-text-field
                                                            v-model="
                                                                date_discount_exp_time
                                                            "
                                                            append-icon="mdi-calendar"
                                                            placeholder="Tanggal"
                                                            readonly
                                                            dense
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            outlined
                                                            hide-details
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="
                                                            date_discount_exp_time
                                                        "
                                                        :min="
                                                            new Date()
                                                                .toISOString()
                                                                .slice(0, 10)
                                                        "
                                                        no-title
                                                        scrollable
                                                    >
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>

                                            <v-col>
                                                <v-menu
                                                    ref="menu"
                                                    v-model="expiredTime.option"
                                                    :close-on-content-click="
                                                        false
                                                    "
                                                    transition="slide-y-reverse-transition"
                                                    offset-y
                                                >
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <v-text-field
                                                            v-model="
                                                                expiredTime.value
                                                            "
                                                            outlined
                                                            placeholder="Waktu"
                                                            append-icon="mdi-clock-time-four-outline"
                                                            dense
                                                            v-bind="attrs"
                                                            style="
                                                                margin-top: -11px;
                                                            "
                                                            hide-details
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-time-picker
                                                        v-if="
                                                            expiredTime.option
                                                        "
                                                        v-model="
                                                            expiredTime.value
                                                        "
                                                        @change="
                                                            expiredTime.option = false
                                                        "
                                                        format="24hr"
                                                    ></v-time-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </div>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Tipe <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <v-select
                                        outlined
                                        placeholder="Pilih Tipe"
                                        :disabled="!!queryId"
                                        dense
                                        v-model="data.package_category"
                                        @change="
                                            ((data.package_type = ''),
                                            (data.expiry_date = ''),
                                            (data.start_date = ''),
                                            (data.addon_value = 0))
                                        "
                                        class="pa-0"
                                        :items="[
                                            {
                                                text: 'PACKAGES',
                                                value: 'PACKAGES',
                                            },
                                            { text: 'ADDON', value: 'ADDON' },
                                        ]"
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Jenis <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <v-select
                                        outlined
                                        placeholder="Pilih Jenis"
                                        :disabled="!!queryId"
                                        dense
                                        v-model="data.package_type"
                                        @change="
                                            ((data.expiry_date = ''),
                                            (data.start_date = ''))
                                        "
                                        :value="
                                            data.package_type =
                                                data.package_category == 'ADDON'
                                                    ? 'QUOTA'
                                                    : data.package_type
                                        "
                                        class="pa-0"
                                        :items="
                                            data.package_category == 'ADDON'
                                                ? [
                                                      {
                                                          text: 'QUOTA',
                                                          value: 'QUOTA',
                                                      },
                                                  ]
                                                : [
                                                      {
                                                          text: 'MONTHLY',
                                                          value: 'MONTHLY',
                                                      },
                                                      {
                                                          text: 'ANNUALLY',
                                                          value: 'ANNUALLY',
                                                      },
                                                      {
                                                          text: '3 MONTH',
                                                          value: 'THREE_MONTH',
                                                      },
                                                      {
                                                          text: '6 MONTH',
                                                          value: 'SIX_MONTH',
                                                      },
                                                      {
                                                          text: '9 MONTH',
                                                          value: 'NINE_MONTH',
                                                      },
                                                      {
                                                          text: 'WEEKLY',
                                                          value: 'WEEKLY',
                                                      },
                                                  ]
                                        "
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                two-line
                                class="pa-0"
                                v-if="data.package_category == 'PACKAGES'"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Kuota Konsul
                                    </v-list-item-title>
                                    <v-text-field
                                        type="number"
                                        placeholder="Kuota Konsul"
                                        v-model="data.consul_session"
                                        dense
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                class="pa-0"
                                v-show="data.package_category !== 'ADDON'"
                            >
                                <v-row>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold font-size-14 pt-2 pb-1"
                                                >
                                                    Waktu Mulai
                                                    <span class="red--text"
                                                        >*</span
                                                    >
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col
                                                            cols="12"
                                                            class="pl-0"
                                                        >
                                                            <v-menu
                                                                ref="menu"
                                                                :close-on-content-click="
                                                                    true
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        :disabled="
                                                                            queryId
                                                                        "
                                                                        v-model="
                                                                            data.start_date
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        readonly
                                                                        dense
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    :disabled="
                                                                        queryId
                                                                    "
                                                                    v-model="
                                                                        data.start_date
                                                                    "
                                                                    :min="
                                                                        new Date()
                                                                            .toISOString()
                                                                            .slice(
                                                                                0,
                                                                                10,
                                                                            )
                                                                    "
                                                                    no-title
                                                                    scrollable
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold font-size-14 pt-2 pb-1"
                                                >
                                                    Waktu Berakhir
                                                    <span class="red--text">
                                                        *
                                                    </span>
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col
                                                            cols="12"
                                                            class="px-0"
                                                        >
                                                            <v-menu
                                                                ref="menu"
                                                                :close-on-content-click="
                                                                    true
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        v-model="
                                                                            data.expiry_date
                                                                        "
                                                                        :disabled="
                                                                            queryId
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        readonly
                                                                        dense
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="
                                                                        data.expiry_date
                                                                    "
                                                                    :disabled="
                                                                        queryId
                                                                    "
                                                                    :min="
                                                                        new Date()
                                                                            .toISOString()
                                                                            .slice(
                                                                                0,
                                                                                10,
                                                                            )
                                                                    "
                                                                    no-title
                                                                    scrollable
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item
                                two-line
                                class="pa-0"
                                v-if="data.package_category !== 'ADDON'"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2"
                                    >
                                        Jenjang <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <v-radio-group
                                        row
                                        :disabled="!!queryId"
                                        v-model="data.package_level"
                                        @change="data.package_grade = []"
                                        mandatory
                                        style="margin-top: -2px"
                                    >
                                        <v-radio
                                            label="SD"
                                            value="SD"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            label="SMP"
                                            value="SMP"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            label="SMA"
                                            value="SMA"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                two-line
                                class="pa-0"
                                v-if="data.package_category !== 'ADDON'"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2"
                                    >
                                        Kelas <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <div style="margin-top: -15px">
                                        <v-radio-group
                                            row
                                            :disabled="!!queryId"
                                            v-if="data.package_level === 'SD'"
                                            v-model="data.package_grade"
                                        >
                                            <v-radio
                                                v-for="i in 6"
                                                :key="i"
                                                :label="'' + i"
                                                :value="i"
                                                class="jenjang-selection"
                                                active-class="act-radio-btn"
                                            ></v-radio>
                                        </v-radio-group>

                                        <v-radio-group
                                            row
                                            :disabled="!!queryId"
                                            v-if="data.package_level === 'SMP'"
                                            v-model="data.package_grade"
                                        >
                                            <v-radio
                                                v-for="i in 3"
                                                :key="i"
                                                :label="'' + (i + 6)"
                                                :value="i + 6"
                                                class="jenjang-selection"
                                                active-class="act-radio-btn"
                                            ></v-radio>
                                        </v-radio-group>

                                        <v-radio-group
                                            row
                                            :disabled="!!queryId"
                                            v-if="data.package_level === 'SMA'"
                                            v-model="data.package_grade"
                                        >
                                            <v-radio
                                                v-for="i in 3"
                                                :key="i"
                                                :label="'' + (i + 9)"
                                                :value="i + 9"
                                                class="jenjang-selection"
                                                active-class="act-radio-btn"
                                            ></v-radio>
                                        </v-radio-group>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                two-line
                                class="pa-0"
                                v-if="data.package_category == 'ADDON'"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Jumlah Kuota
                                    </v-list-item-title>
                                    <v-text-field
                                        type="number"
                                        v-model="data.addon_value"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <!-- <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Paket Rekomendasi
                                    </v-list-item-title>
                                    <v-checkbox
                                        label="Direkomendasikan"
                                        v-model="data.is_recommended"
                                        :false-value="false"
                                        :true-value="true"
                                        class="pa-0 ma-0"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Paket IOS
                                    </v-list-item-title>
                                    <v-checkbox
                                        label="Paket IOS"
                                        v-model="data.is_ios"
                                        :false-value="0"
                                        :true-value="1"
                                        class="pa-0 ma-0"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        Is Show
                                    </v-list-item-title>
                                    <v-checkbox
                                        label="Is Show"
                                        v-model="data.is_show"
                                        :false-value="0"
                                        :true-value="1"
                                        class="pa-0 ma-0"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item> -->

                            <div>
                                <div
                                    class="font-weight-bold black--text font-size-14 pt-2"
                                >
                                    Tampilkan Paket
                                </div>

                                <v-switch
                                    v-model="data.is_show"
                                    inset
                                    :false-value="0"
                                    :true-value="1"
                                    class="font-size-12"
                                    color="success"
                                    style="margin-top: 7px"
                                >
                                    <template v-slot:label>
                                        <span class="font-size-14">
                                            {{
                                                data.is_show === 1
                                                    ? "Paket Ditampilkan"
                                                    : "Paket Tidak Ditampilkan"
                                            }}
                                        </span>
                                    </template>
                                </v-switch>
                            </div>

                            <div
                                class="font-weight-bold black--text font-size-14 mt-8"
                            >
                                Pengaturan Lainnya
                            </div>

                            <div
                                class="d-flex mt-1"
                                style="gap: 20px; padding-top: -20px"
                            >
                                <v-checkbox
                                    v-model="data.is_recommended"
                                    :false-value="false"
                                    :true-value="true"
                                    class="pa-0 ma-0"
                                    outlined
                                >
                                    <template v-slot:label>
                                        <span
                                            class="font-size-14 d-flex align-center"
                                        >
                                            Paket Rekomendasi
                                            <v-chip
                                                x-small
                                                color="#E1F5FE"
                                                dark
                                                class="px-2 py-3 ml-1"
                                                style="color: #0277bd"
                                            >
                                                Untuk Skolla App
                                            </v-chip>
                                        </span>
                                    </template>
                                </v-checkbox>

                                <v-checkbox
                                    label="Paket untuk IOS"
                                    v-model="data.is_ios"
                                    :false-value="0"
                                    :true-value="1"
                                    class="pa-0 ma-0"
                                    outlined
                                />
                            </div>

                            <div
                                class="font-weight-bold black--text font-size-14 mt-8 d-flex align-center"
                            >
                                Sorotan Produk

                                <v-chip
                                    x-small
                                    color="#E0F2F1"
                                    dark
                                    class="px-2 py-3 ml-1"
                                    style="color: #00897b"
                                >
                                    Untuk Web Purchase
                                </v-chip>
                            </div>

                            <div>
                                <v-radio-group
                                    v-model="data.badge"
                                    row
                                    style="margin-top: 10px"
                                >
                                    <v-radio
                                        label="Rekomendasi"
                                        value="RECOMMENDED"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                    <v-radio
                                        label="Pilihan Terbaik"
                                        value="BEST_VALUES"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                    <v-radio
                                        label="Banyak Dibeli"
                                        value="MOST_PURCHASED"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                </v-radio-group>
                            </div>

                            <v-list-item
                                two-line
                                class="pa-0 mt-3"
                                v-show="data.package_category === 'PACKAGES'"
                            >
                                <v-list-item-content class="pt-0 px-0 pb-6">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        User Group
                                    </v-list-item-title>
                                    <v-autocomplete
                                        outlined
                                        :items="userGroups"
                                        item-text="name"
                                        item-value="id"
                                        hide-details
                                        placeholder="Pilih User Group"
                                        v-model="data.user_group_id"
                                        dense
                                        class="pa-0"
                                    ></v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                v-show="data.package_category === 'PACKAGES'"
                                two-line
                                class="pa-0"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        User Scope
                                    </v-list-item-title>
                                    <v-autocomplete
                                        v-model="data.app_scope"
                                        :items="app_scope"
                                        item-text="display_name"
                                        item-value="id"
                                        placeholder="Pilih App Scope"
                                        class="custom-chips-spacing"
                                        outlined
                                        multiple
                                        dense
                                        :disabled="
                                            data.package_category !==
                                                'PACKAGES' || !!queryId
                                        "
                                    >
                                        <!-- :disabled=" data.package_category !=
                                        'PACKAGES' || !!queryId " -->

                                        <!--chips--->
                                    </v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- <v-list-item
                                two-line
                                class="pa-0"
                                v-show="data.package_category === 'PACKAGES'"
                            >
                                <v-list-item-content class="pt-0 px-0 pb-6">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pt-2 pb-1"
                                    >
                                        User Scope
                                        <span class="red--text">*</span>
                                    </v-list-item-title>
                                    <v-select
                                        :disabled="!!queryId"
                                        :items="app_scope"
                                        item-text="name"
                                        item-value="id"
                                        class="pb-2"
                                        hide-details
                                        placeholder="Pilih User Scope"
                                        outlined
                                        dense
                                        v-for="(fitur, i) in data.app_scope"
                                        :key="i"
                                        v-model="data.app_scope[i]"
                                    >
                                        <template v-slot:append-outer>
                                            <v-btn
                                                text
                                                class="font-weight-bold dark--text py-3 mt-2"
                                                color="redLight"
                                                v-if="
                                                    i ===
                                                        data.app_scope.length -
                                                            1 &&
                                                    data.app_scope.length != 1
                                                "
                                                @click="
                                                    queryId
                                                        ? null
                                                        : data.app_scope.splice(
                                                              i,
                                                              1
                                                          )
                                                "
                                            >
                                                Hapus
                                            </v-btn>
                                        </template>
                                    </v-select>
                                </v-list-item-content>
                            </v-list-item>

                            <v-card flat class="pa-0">
                                <v-btn
                                    :disabled="
                                        data.package_category != 'PACKAGES' ||
                                        !!queryId
                                    "
                                    @click="data.app_scope.push('')"
                                    block
                                    depressed
                                    class="font-weight-bold blew--text"
                                    color="#e8f5fa"
                                >
                                    <v-icon style="font-size: 16px !important"
                                        >mdi-plus-circle</v-icon
                                    >
                                    Tambah Scope Baru
                                </v-btn>

                                <v-btn
                                    depressed
                                    block
                                    class="my-3"
                                    color="blew white--text"
                                    @click="openDialogSequence()"
                                >
                                    <v-icon style="font-size: 16px !important">
                                        mdi-sort
                                    </v-icon>

                                    Atur Urutan Paket
                                </v-btn>
                            </v-card> -->

                            <v-btn
                                v-show="queryId"
                                depressed
                                block
                                class="my-3"
                                color="blew white--text"
                                @click="openDialogSequence()"
                            >
                                <v-icon style="font-size: 16px !important">
                                    mdi-sort
                                </v-icon>

                                Atur Urutan Paket
                            </v-btn>

                            <v-card
                                elevation="0"
                                class="px-0 pt-0 mt-7 ma-0 pb-8"
                                v-show="
                                    data.package_category === 'PACKAGES' &&
                                    liveclass_schedulled
                                "
                            >
                                <div class="font-weight-bold font-size-14">
                                    Jadwal Kelas
                                    <span class="red--text">*</span>
                                </div>

                                <v-simple-table class="mb-5">
                                    <thead>
                                        <tr>
                                            <td>ID</td>
                                            <td>Deskripsi</td>
                                            <td>Threshold</td>
                                            <td>Mulai</td>
                                            <td>Berakhir</td>
                                            <td>Aksi</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            v-for="(tryout, index) in tryouts"
                                            v-bind:key="index"
                                        >
                                            <td>
                                                {{ tryout.id }}
                                            </td>
                                            <td>
                                                {{ tryout.desc }}
                                            </td>
                                            <td>
                                                {{ tryout.threshold }}
                                            </td>
                                            <td>
                                                {{ tryout.start_time }}
                                            </td>
                                            <td>
                                                {{ tryout.end_time }}
                                            </td>
                                            <td>
                                                <v-btn
                                                    class="pa-0 red--text"
                                                    color="lightred"
                                                    small
                                                    depressed
                                                    @click="
                                                        removeTryoutFromGroup(
                                                            group,
                                                        )
                                                    "
                                                >
                                                    Hapus
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>

                                <!-- <v-card
                                    outlined
                                    class="my-3"
                                    v-for="(tryout, index) in tryouts"
                                    v-bind:key="index"
                                >
                                    <v-list class="pa-0 text-subtitle-2">
                                        <template>
                                            <v-list-item two-line>
                                                <v-list-item-content
                                                    class="mx-2 my-0 align-self-start"
                                                    style="max-width: 10%"
                                                >
                                                    <v-list-item-subtitle
                                                        class="font-weight-bold"
                                                    >
                                                        ID
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle
                                                        style="
                                                            text-overflow: unset;
                                                            white-space: unset;
                                                        "
                                                    >
                                                        {{ tryout.id }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-content
                                                    class="mx-2 my-0 align-self-start"
                                                >
                                                    <v-list-item-subtitle
                                                        class="font-weight-bold"
                                                    >
                                                        Deskripsi
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle>
                                                        {{ tryout.desc }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-content
                                                    class="mx-2 my-0 align-self-start"
                                                >
                                                    <v-list-item-subtitle
                                                        class="font-weight-bold"
                                                    >
                                                        Threshold
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle>
                                                        {{ tryout.threshold }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-content
                                                    class="mx-2 my-0 align-self-start"
                                                >
                                                    <v-list-item-subtitle
                                                        class="font-weight-bold"
                                                    >
                                                        Mulai
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle>
                                                        {{ tryout.start_time }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-content
                                                    class="mx-2 my-0 align-self-start"
                                                >
                                                    <v-list-item-subtitle
                                                        class="font-weight-bold"
                                                    >
                                                        Berakhir
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle>
                                                        {{ tryout.end_time }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-btn
                                                        plain
                                                        class="pa-0"
                                                        @click="
                                                            removeTryoutFromGroup(
                                                                group
                                                            )
                                                        "
                                                    >
                                                        <span
                                                            class="red--text"
                                                            :class="
                                                                $vuetify
                                                                    .breakpoint
                                                                    .mdAndUp
                                                                    ? 'font-weight-700'
                                                                    : 'font-weight-600'
                                                            "
                                                            :style="
                                                                $vuetify
                                                                    .breakpoint
                                                                    .smAndDown
                                                                    ? 'font-size: 12px'
                                                                    : ''
                                                            "
                                                            >Hapus</span
                                                        >
                                                    </v-btn>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-card> -->

                                <app-jadwalkelaschooser
                                    v-on:selected="addTryoutIntoGroup($event)"
                                ></app-jadwalkelaschooser>
                            </v-card>

                            <v-divider></v-divider>

                            <v-card-actions class="py-2 mt-5">
                                <v-spacer></v-spacer>

                                <v-btn
                                    text
                                    @click="$router.push({ path: '/produk' })"
                                >
                                    Batal
                                </v-btn>

                                <v-btn
                                    color="primary"
                                    depressed
                                    @click="upload()"
                                >
                                    Simpan
                                </v-btn>
                            </v-card-actions>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-card>
        </v-card>

        <v-dialog v-model="dialogPackageSequence" scrollable width="940px">
            <dialog-package-sequence
                v-if="dialogPackageSequence"
                @close="dialogPackageSequence = false"
            />
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Jadwalkelaschooser from "@/modules/pembayaran/components/JadwalKelasChooser";
import { applyOssCredentials } from "@/modules/global/services/oss";
import Moment from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";
import dialogPackageSequence from "./dialogPackageSequence.vue";
import uniqid from "uniqid";

export default {
    name: "produk-form",

    components: {
        "app-jadwalkelaschooser": Jadwalkelaschooser,
        "app-spinner": Spinner,
        dialogPackageSequence,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            dialogPackageSequence: false,
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            type: {
                SUBSCRIPTION: "SUBSCRIPTION",
                TICKET: "TICKET",
            },
            queryId: null,
            selectedPicture: null,
            data: {
                banner_picture: "",
                package_level: "",
                type: "SUBSCRIPTION",
                discount: null,
                referral_discount: null,
                package_name: null,
                package_type: "",
                app_scope: [],
                user_group_id: null,
                package_description: null,
                package_category: "",
                package_grade: null,
                package_groups: [],
                code: "",
                consul_session: "",
                normal_price: 0,
                start_date: "",
                expiry_date: "",
                actual_price: 0,
                is_recommended: false,
                is_active: 1,
                is_show: 0,
                is_ios: 0,
                discount_exp_time: null,
                badge: null,
            },
            url: null,
            imageFile: null,
            image: null,
            keyimg: 0,
            userGroups: [],
            tryouts: [],
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "blockQuote",
                    "|",
                    "outdent",
                    "indent",
                ],
            },
            app_scope: [],
            scopes: [
                {
                    id: 8,
                    text: "app_scheduled_tryout",
                    display_text: "User: Access Scheduled Tryout",
                    description:
                        "Give user privilege to access scheduled tryout feature",
                    created_at: "2019-03-13 00:47:03",
                    updated_at: "2019-03-13 00:47:03",
                },
                {
                    id: 9,
                    text: "app_itembank",
                    display_text: "User: Access Itembank",
                    description:
                        "Give user privilege to access itembank feature",
                    created_at: "2019-03-13 00:47:03",
                    updated_at: "2019-03-13 00:47:03",
                },
                {
                    id: 55,
                    text: "app_consultation",
                    display_text: "app_consultation",
                    display_name: "User: Access Consultation",
                    description:
                        "Give privileges to access consultation features",
                    created_at: "2020-05-04 02:44:01",
                    updated_at: "2020-05-04 02:44:01",
                },
                {
                    id: 64,
                    text: "app_liveclass",
                    display_text: "app_liveclass",
                    display_name: "User: Access Live Class",
                    description:
                        "Give privileges to access live class features",
                    created_at: "2021-07-18 12:20:45",
                    updated_at: "2021-07-18 12:32:06",
                },
            ],
            topic: null,
            startDate: null,
            endDate: null,
            liveclass_schedulled: false,
            expiredTime: {
                option: false,
                value: null,
            },
            date_discount_exp_time: null,
            time_discount_exp_time: null,
            is_discount_exp: false,
        };
    },

    computed: {
        discount_exp_time() {
            const date = this.date_discount_exp_time;
            const time = this.expiredTime.value || "00:00:00";
            const datetime = `${date} ${time}:00`;

            return this.is_discount_exp ? datetime : null;
        },
    },

    watch: {
        "data.app_scope": function (val) {
            var check_app_scope = val.includes(64);
            if (check_app_scope) {
                this.liveclass_schedulled = true;
            } else {
                this.liveclass_schedulled = false;
            }
        },
    },

    mounted: function () {
        var context = this;
        if (this.$route.query.id) {
            this.queryId = this.$route.query.id;
            this.fetchData();
        }
        if (!this.$route.query.id) {
            DatepickerPlugin.init("#startDate", function (value) {
                context.data.start_date = value;
            });

            DatepickerPlugin.init("#endDate", function (value) {
                context.data.expiry_date = value;
            });
        }
        this.getUserGroup();
        this.getAppScope();
    },

    methods: {
        fetchData: function () {
            var context = this;
            var queryId = this.queryId;
            var jadwalkelases = [];
            this.isLoading = true;

            SalesService.getDetailPaket(queryId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    context.data.banner_picture = result.data.banner_picture;
                    context.url = result.data.banner_picture;

                    context.data.package_name = result.data.name;
                    context.data.package_type = result.data.type;
                    context.data.discount = result.data.discount;
                    context.data.referral_discount =
                        result.data.referral_discount;

                    context.data.app_scope = result.data.package_app_scope;
                    context.data.package_description = result.data.description;
                    context.data.feature_description =
                        result.data.feature_package;
                    context.data.package_category =
                        result.data.package_category;
                    context.data.user_group_id = result.data.user_group_id;
                    context.data.addon_value = result.data.addon_value;
                    if (context.data.package_category === "PACKAGES") {
                    }
                    if (result.data.grade_package !== null) {
                        context.data.package_grade =
                            result.data.grade_package[0];
                    }
                    context.data.package_level = result.data.level;
                    context.data.normal_price = result.data.normal_price;
                    context.data.actual_price = result.data.actual_price;
                    context.data.consul_session = result.data.consul_session;
                    context.data.is_recommended = result.data.is_recommended;
                    context.data.is_show = result.data.is_show;
                    context.data.is_ios = result.data.is_ios;
                    context.data.badge = result.data.badge;

                    if (result.data.discount_exp_time) {
                        const discount_exp_time = Moment(
                            result.data.discount_exp_time,
                        ).format("YYYY-MM-DD HH:mm");

                        const [date_expired, time_expired] =
                            discount_exp_time.split(" ");

                        context.date_discount_exp_time = date_expired;
                        context.expiredTime.value = time_expired;
                        context.is_discount_exp = true;
                    }

                    if (result.data.start_date) {
                        context.data.start_date = Moment(
                            result.data.start_date,
                        ).format("YYYY-MM-DD");
                        context.data.expiry_date = Moment(
                            result.data.expiry_date,
                        ).format("YYYY-MM-DD");
                    }

                    result.data.package_group.forEach((element) => {
                        const datas = {
                            id: element.id,
                            desc: element.description,
                            quota: element.quota,
                            threshold: element.threshold,
                            start_time: Moment(element.start_time).format(
                                "HH:mm",
                            ),
                            end_time: Moment(element.end_time).format("HH:mm"),
                        };
                        context.data.package_groups.push(element.id);
                        jadwalkelases.push(datas);
                    });

                    context.tryouts = jadwalkelases;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        submessage: result.message,
                        type: "error",
                    });
                }
            });
        },

        addTryoutIntoGroup: function (tryout) {
            const datas = {
                id: tryout.id,
                desc: tryout.description,
                quota: tryout.quota,
                threshold: tryout.threshold,
                start_time: tryout.start_time,
                end_time: tryout.end_time,
            };
            this.data.package_groups.push(tryout.id);
            this.tryouts.push(datas);
        },

        removeTryoutFromGroup: function (index) {
            var confirmed = window.confirm(
                "Apakah anda yakin akan melepas Jadwal ini?",
            );

            if (confirmed) {
                this.data.package_groups.splice(index, 1);
                this.tryouts.splice(index, 1);
            }
        },
        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 300000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 300 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
            console.log(this.imageFile);
        },

        async upload(e) {
            this.isLoading = true;
            if (!this.imageFile && !this.data.banner_picture) {
                this.$store.commit("showAlert", {
                    message: `Gambar wajib diisi!`,
                    type: "error",
                });

                this.isLoading = false;
                return false;
            }

            if (this.validateForm()) {
                var file = this.imageFile;

                if (this.data.banner_picture && !file) {
                    this.image = this.data.banner_picture;
                    if (this.$route.query.id) {
                        this.editData();
                    } else {
                        this.saveData();
                    }
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan pada upload!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET,
                        Key: "paket/" + file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan pada upload!`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.data.banner_picture = data.Location;
                            if (context.$route.query.id) {
                                context.editData();
                            } else {
                                context.saveData();
                            }
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        saveData: function () {
            var context = this;
            var data = this.data;

            if (this.validateForm()) {
                context.isLoading = true;
                if (context.data.package_category === "PACKAGES") {
                    data.package_grade = Array.isArray(data.package_grade)
                        ? data.package_grade
                        : [data.package_grade];

                    data.package_level = data.package_level || null; // tetap ada field-nya
                } else {
                    data.package_grade = []; // tetap array
                    data.package_level = "ALL"; // tetap ada nilai default
                }

                // data.start_date = Moment(data.start_date, "YYYY-MM-DD").format(
                //     "DD/MM/YYYY",
                // );

                // data.expiry_date = Moment(
                //     data.expiry_date,
                //     "YYYY-MM-DD",
                // ).format("DD/MM/YYYY");

                data.discount_exp_time = context.discount_exp_time;

                SalesService.createPaket(data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        editData: function () {
            var context = this;
            var id = this.queryId;
            var data = this.data;

            if (context.is_discount_exp && !context.date_discount_exp_time) {
                context.$store.commit("showAlert", {
                    message: `Lengkapi isian tanggal berakhir diskon terlebih dahulu!`,
                    type: "error",
                });

                this.isLoading = false;
                return;
            }

            if (this.validateForm()) {
                this.isLoading = true;
                if (context.data.package_category === "PACKAGES") {
                    data.package_grade = Array.isArray(data.package_grade)
                        ? data.package_grade
                        : [data.package_grade];

                    data.package_level = data.package_level || null; // tetap ada field-nya
                } else {
                    data.package_grade = []; // tetap array
                    data.package_level = "ALL"; // tetap ada nilai default
                }

                // data.start_date = Moment(data.start_date, "YYYY-MM-DD").format(
                //     "DD/MM/YYYY",
                // );
                // data.expiry_date = Moment(
                //     data.expiry_date,
                //     "YYYY-MM-DD",
                // ).format("DD/MM/YYYY");

                data.discount_exp_time = context.discount_exp_time;

                SalesService.updatePaket(id, data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        doUploadPicture: function (id) {
            var context = this;
            var picture = this.selectedPicture;
            var formData = new FormData();

            if (picture) {
                formData.append("name", picture.name);
                formData.append("file", picture);

                SalesService.uploadPaketPicture(
                    id,
                    formData,
                    function (result) {
                        if (result.success)
                            context.$router.push({ path: "/produk" });
                        else {
                            context.$store.commit("showAlert", {
                                message: `Terjadi Kesalahan!`,
                                submessage: result.message,
                                type: "error",
                            });
                            context.isLoading = false;
                        }
                    },
                );
            } else {
                context.$router.push({ path: "/produk" });
            }
        },

        validateForm() {
            var err = false;
            var context = this;
            if (!this.data.package_category) {
                this.$store.commit("showAlert", {
                    message: `Tipe produk wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else {
                if (!this.data.package_name) {
                    this.$store.commit("showAlert", {
                        message: `Nama Paket wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.package_level) {
                    this.$store.commit("showAlert", {
                        message: `Jenjang wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.package_description) {
                    this.$store.commit("showAlert", {
                        message: `Deskripsi wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (this.data.package_category === "PACKAGES") {
                    if (this.data.package_grade.length < 1) {
                        this.$store.commit("showAlert", {
                            message: `Kelas wajib diisi!`,
                            type: "error",
                        });
                        err = true;
                    }
                }

                if (!this.data.feature_description) {
                    this.$store.commit("showAlert", {
                        message: `Fitur wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.actual_price) {
                    this.$store.commit("showAlert", {
                        message: `Harga Asli wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!!this.data.normal_price) {
                    if (
                        Number(this.data.actual_price) >=
                        Number(this.data.normal_price)
                    ) {
                        this.$store.commit("showAlert", {
                            message: `Harga Asli tidak boleh lebih dari atau sama dengan Harga Normal!`,
                            type: "error",
                        });
                        err = true;
                    }
                }

                if (this.data.package_category === "PACKAGES") {
                    if (this.data.package_grade.length < 1) {
                        this.$store.commit("showAlert", {
                            message: `Kelas wajib diisi!`,
                            type: "error",
                        });
                        err = true;
                    }

                    if (!this.data.package_level) {
                        this.$store.commit("showAlert", {
                            message: `Jenjang wajib diisi!`,
                            type: "error",
                        });
                        err = true;
                    }

                    if (!this.data.app_scope.length) {
                        context.$store.commit("showAlert", {
                            message: `User scope wajib diisi!`,
                            type: "error",
                        });
                    }

                    var check_app_scope = this.data.app_scope.includes(64);
                    if (check_app_scope) {
                        if (this.data.package_groups.length < 1) {
                            this.$store.commit("showAlert", {
                                message: `Jadwal Kelas wajib diisi!`,
                                type: "error",
                            });
                            err = true;
                        }
                    }
                } else {
                    this.data.app_scope = [];
                    this.data.package_groups = [];
                }

                if (
                    this.data.package_category === "PACKAGES" &&
                    !this.data.start_date
                ) {
                    this.$store.commit("showAlert", {
                        message: `Tanggal mulai wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (
                    this.data.package_category === "PACKAGES" &&
                    !this.data.expiry_date
                ) {
                    this.$store.commit("showAlert", {
                        message: `Tanggal selesai wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                    this.errors.push("Tanggal selesai wajib di isi");
                }
            }
            return !err;
        },

        getUserGroup() {
            this.userGroups = [];
            var context = this;
            var search = null;

            SalesService.getListUserGroup((result) => {
                if (result.success) {
                    result.data.user_groups.forEach((items) => {
                        var row = {
                            id: items.id,
                            name: items.user_group_name,
                        };
                        context.userGroups.push(row);
                    });
                }
            });
        },

        getAppScope() {
            this.app_scope = [];
            var context = this;

            SalesService.getListAppScope((result) => {
                if (result.success) {
                    result.data.forEach((items) => {
                        var row = {
                            id: items.id,
                            name: items.name,
                            display_name: items.display_name,
                        };
                        context.app_scope.push(row);
                    });
                }
            });
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },

        openDialogSequence() {
            this.dialogPackageSequence = true;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}

.custom-chips-spacing .v-chip {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
    background-color: #e8f5fa !important;
    color: #2dafe7;
    font-weight: 500 !important;
}
</style>



// WEBPACK FOOTER //
// ProdukForm.vue?02d14944